/*
	References a row drill-down button (i.e. the + to the left of a row)
*/
class RowDrilldownRef {
  constructor(row, option, parent) {
    this._row = row; // DataTableRow
    this._option = option; // DrilldownOption
    this._parent = parent; // RowDrilldownRef
  }

  row() {
    return this._row;
  }

  option() {
    return this._option;
  }

  parent() {
    return this._parent;
  }

  /*
		When traversing this tree (in rows reducer) we actually want the tree to be upside down
		so this method builds an inverted version of this object.

		Note: users of this method should call it with null as the parameter!
	*/
  inverse(parent = null) {
    const ref = new RowDrilldownRef(this.row(), this.option(), parent);
    if (!this.parent()) {
      return ref;
    }
    return this.parent().inverse(ref);
  }
}

export default RowDrilldownRef;
